import { Routes} from '@angular/router';

export const certificatesRoutes: Routes = [
  {
    path: ':id',
    loadComponent: () => import('./certificates.component').then(m => m.CertificatesComponent),
  }
];
